import styled, { css } from 'styled-components';
import COLORS from '../../constants/colors.js';
import FONTS from '../../constants/fonts.js';
import '../../constants/theme.js';
import '../../constants/files.js';
import '../../constants/color-variant.js';
import '../../constants/zIndexList.js';
import { CommonElementSizeMap } from '../../constants/ui.js';
import '../../mixins/style-mixins.js';
import '../../mixins/scrollbar.js';
import '../../mixins/cursor.js';
import { getCommonFontStyleMixin } from '../../mixins/font.js';

const StyledSelectWrapper = styled.div `
    ${(props) => {
    const size = props === null || props === void 0 ? void 0 : props.size;
    switch (size) {
        case "sm":
            return css `
                    height: ${CommonElementSizeMap[size]};
                    &,
                    .select-value-container [data-select-value-label] {
                        ${getCommonFontStyleMixin({ size })};
                    }
                `;
        default:
            return css `
                    font-size: 16px;
                    height: 48px;
                `;
    }
}};

    .select-container {
        height: 100%;
    }
    .select-control {
        font-size: 12px;
        height: 100%;
        outline: none;
        padding: 0 16px;
        box-shadow: none;

        ${({ outline }) => {
    switch (outline) {
        case "border":
            return css `
                        border: 1px solid ${COLORS.GREY_200};
                    `;
        case "underline":
            return css `
                        border: none;
                        border-radius: 0;
                        border-bottom: 2px solid ${COLORS.GREY_200};
                    `;
        default:
            return css ``;
    }
}}

        ${({ borderRadius }) => borderRadius
    ? css `
                      border-radius: ${borderRadius}px;
                  `
    : ""}

        &:hover {
            border-color: ${COLORS.BLUE};
        }
    }

    .select-value-container {
        padding: 0;
        overflow: hidden;
        height: 100%;
    }

    .select-singleValue {
        margin-left: 5px;
        color: ${COLORS.GREY_1000};
    }

    .select-option {
        background-color: ${COLORS.WHITE};
        color: ${COLORS.GREY_1000};

        &:hover {
            color: ${COLORS.WHITE};
            background-color: ${COLORS.BLUE};
        }

        &.selected,
        &.focused {
            color: ${COLORS.WHITE};
            background-color: ${COLORS.BLUE};
        }

        &.disabled {
            color: ${COLORS.WHITE};
            background-color: ${COLORS.GREY_600};
            cursor: not-allowed;
        }
    }

    .select-input {
        input {
            caret-color: transparent;
        }
    }

    .select-control--searchable .select-input {
        color: ${COLORS.GREY_1000};
        cursor: text;

        input {
            caret-color: ${COLORS.BLUE};
            color: inherit;
            cursor: text;
            font-size: 16px;
            opacity: 1 !important;
        }
    }

    .select-placeholder {
        color: ${COLORS.GREY_400};
        font-family: ${FONTS.REGULAR};
        font-size: 13px;
    }

    .select-dropDownIndicator {
        svg {
            width: 18px;
            height: 18px;
            transform: rotate(90deg);
        }
    }
    .select-customDropDownIndicator {
        padding: 0;
    }

    .select-noOptionMessage {
        color: ${COLORS.BLUE};
    }

    .select-multiValue {
        background-color: ${COLORS.GREY_300};
        border: 2px solid ${COLORS.RED};
        padding: 2px;
    }

    .select-customDropDownIndicator,
    .select-clear {
        cursor: pointer;
    }
`;

export { StyledSelectWrapper };
//# sourceMappingURL=Select.styles.js.map
